import React, { useContext } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';

import MiniCalc from '../MiniCalc/MiniCalc';

import SidebarArticles from './SidebarArticles';
import { TEMPLATE_TOKENS } from '../../../constants/Languages';

import './Sidebar.scss';
import layoutContext from '../../layoutContext';

const Sidebar = ({ stocks, news, articles, calculator }) => {
  const { cult } = useContext(layoutContext);
  return (
    <StaticQuery
      query={graphql`
        query {
          pages: allMarkdownRemark(
            sort: { fields: [frontmatter___date], order: DESC }
            filter: { fileAbsolutePath: { regex: "/content/news/" } }
          ) {
            totalCount
            edges {
              node {
                frontmatter {
                  headLine
                  path
                  category
                  lang
                }
              }
            }
          }
        }
      `}
      render={data => {
        const {
          lastNews,
          lastArticles, } = TEMPLATE_TOKENS[cult];
        const lastStocks = TEMPLATE_TOKENS[cult].stocks;
        const { pages } = data;
        const { edges } = pages;
        const newsArr = [];
        const articlesArr = [];
        const stocksArr = [];


        edges.forEach(({
          node: { frontmatter: { headLine, path, category, lang } }
        }) => {
          if (stocks &&
            lang === cult &&
            category === 'stocks' &&
            stocksArr.length < 5
          ) {
            stocksArr.push({ headLine, path });
          }

          if (lang === cult &&
            category === 'news' &&
            newsArr.length < 5
          ) {
            newsArr.push({ headLine, path });
          }

          if (lang === cult &&
            category === 'articles' &&
            articlesArr.length < 9
          ) {
            articlesArr.push({ headLine, path });
          }
        }
        );


        return (
          <div className='sidebar'>
            {calculator &&
              <MiniCalc />
            }
            {stocks &&
              <SidebarArticles title={lastStocks} pages={stocksArr} />
            }
            {news &&
              <SidebarArticles title={lastNews} pages={newsArr} />
            }
            {articles &&
              <SidebarArticles
                title={lastArticles}
                pages={articlesArr}
              />
            }
          </div>
        );
      }}
    />
  );
};

export default Sidebar;

Sidebar.propTypes = {
  stocks: PropTypes.bool,
  news: PropTypes.bool,
  articles: PropTypes.bool,
  calculator: PropTypes.bool,
};
